<template>
  <div class="app-container">
    <wt-form-table :form.sync="form" @on-button-action="onButtonAction" ></wt-form-table>
  </div>
</template>

<script>
export default {
  name: 'SiteDelivery',
  data() {
    return {
      form: { //  表单数据
        isFormLoading: false,
        formCode: 'MODULE_SITE_DELIVERY',
        formComponent: {
          view: { type: 'component',
            componentName: 'SiteDeliveryView',
            noRequest: true,
            detailData: {
              siteId: '' }},
          list: { type: 'default', value: '/modules/site/siteList' }
        },
        formInputsData: [
          { name: '站点名称', key: 'name', value: '', type: 'text' },
          { name: '社区', key: 'communityId', value: '', type: 'select', data: [] }],
        formButtonsData: [],
        formTableData: [
          { name: '社区', key: 'communityName', type: 'text' },
          { name: '站点名称', key: 'name', type: 'text' },
          { name: '站点位置', key: 'address', type: 'text' }],
        formTableButtonsData: [{ name: '投递记录', key: 'VIEW', action: 'VIEW', className: 'primary', hidden: false, permission: 'RECORD' }],
        formResult: { },
        pageData: { currentPage: 0, pageSize: 20, sortName: '', sortOrder: '' },
        formTableProp: { selection: false, index: true }
      }
    }
  },
  mounted() {
    this.requestcommunityList()
  },
  methods: {
    onButtonAction(data) {
      if (data && data.item) {
        if (data.item.action === 'VIEW' || data.item.action === 'EDIT') {
          this.form.formComponent.view.detailData.siteId = data.row.id
        }
      }
    },
    /*  ------------------------- 接口请求  -------------------------  */
    requestcommunityList() {
      this.$api.community.communityNoPageList().then(res => {
        for (const item of res.data) {
          item.label = item.name
          item.value = item.id
        }
        this.form.formInputsData[1].data = res.data
      })
    }
  }
}
</script>

<style>
</style>
